import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { DataOrder } from 'src/app/models/DataOrder';
import { GeneralStaff } from 'src/app/models/GeneralStaff';
import { Job } from 'src/app/models/Job';
import { NocSizes } from 'src/app/models/NocSizes';
import { Order } from 'src/app/models/Order';
import { Ribbon } from 'src/app/models/Ribbon';
import { Weapon } from 'src/app/models/Weapon';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-store-order-request',
  templateUrl: './store-order-request.component.html',
  styleUrls: ['./store-order-request.component.scss']
})
export class StoreOrderRequestComponent implements OnInit {

  public nid: string;
  public savedOrder: Order = undefined;
  //public originalOrder: Order;
  public version: string = 'HMAC_SHA256_V1';
  public parameters: string;
  public signature: string;
  public order: Order = new Order();
  public selectAddress: number;
  public separatedOrders: Order[];
  public mapDetail = new Map();
  public disabled: any;
  public imagesUrl: string = CONSTANTES.imagesUrl;
  public clothSelected: string;
  public clothes: string[] = [];
  public sizeSelected: NocSizes;
  public sizes: NocSizes[] = [];
  public clothesList: Clothes[] = [];
  public nocSelected: string;
  public storeTicketNumber: string;
  public jobs: Job[] = [];
  public jobSelected: Job;
  public ribbons: Ribbon[] = [];
  public ribbonSelected: Ribbon;
  public weapons: Weapon[] = [];
  public weaponSelected: Weapon;
  public generalStaffs: GeneralStaff[] = [];
  public generalStaffSelected: GeneralStaff;
  public sizeSelectedCinta: string;
  public recoveredOrders: Order[] = [];
  public timeLeft: string = '';
  public intervalId: any;
  public showClock: boolean = false;
  public modifiedDetail: any = undefined;

  @ViewChild('confirmModal') confirmModal: ModalDirective;
  @ViewChild('printModal') printModal: ModalDirective;

  constructor(private spinner: NgxSpinnerService, private router: Router, private orderService: OrderService,
    private toastr: ToastrService, private authService: AuthenticationService, private clothesService: ClothesService,
   private route: ActivatedRoute, private cdRef: ChangeDetectorRef) { }

async ngOnInit() {
  try {
    jQuery.getScript(CONSTANTES.menu);
    this.nid = localStorage.getItem("nid");
  } catch (Error) {
    this.router.navigate(['login']);
  }

  this.route.queryParams.subscribe(async params => {
    this.spinner.show();
    await this.getClothesList();
  });
}


  async getClothesList(){
    this.clothesList = [];
    this.clothes = [];
    
    let data = await this.clothesService.getClothesWithNocSizes().toPromise(); 
    if (data.clothes != null || data.clothes.length == 0) {
      this.clothesList = data.clothes;
      for (let i = 0; i < this.clothesList.length; i++) {
          if (this.clothesList[i].name != null){
            this.clothes.push(this.clothesList[i].name);
          }
      }
    }
    this.spinner.hide();
    await this.getOrder();
  }

  // Función para obtener los pedidos guardados del usuario
  async getOrder(){
    this.spinner.show();
    this.recoveredOrders = []
    this.showClock = false;
    this.savedOrder = undefined
    let dataOrder: DataOrder = {
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: this.nid,
      orders: null,
      status: null,
      receiptOrders: null,
      dataBank: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: localStorage.getItem("role"),
      noc: null,
      storeTicketNumber: null
    }
    let data: DataOrder = await this.orderService.getOrdersToConfirm(dataOrder).toPromise();
    if (getToken(data)){
      if (data.orders !== null && data.orders.length > 0) {
        this.recoveredOrders = data.orders.filter(o => {
          const start = new Date(o.creationDate).getTime();
          const end = start + 2 * 60 * 60 * 1000;
          return end > Date.now(); // mantiene solo los que están dentro del rango
        });
        //this.savedOrder = data.orders[0];
        this.recoveredOrders.forEach(order =>{
          order.orderDetails.forEach(orderDetail => {
          // Ordenamos los precios por fecha
          let prices = orderDetail.clothes.prices.filter(p => new Date(p.priceDate) < new Date(order.creationDate));
          orderDetail['price'] = prices.sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
          
          // Dejamos solo una imagen para mostrar
          for (let i: number = orderDetail.clothes.pictures.length -1; i >= 0; i--){
            if (orderDetail.clothes.pictures[i].deleted === true){
              orderDetail.clothes.pictures.splice(i,1);
            } else if (orderDetail.clothes.pictures[i].fileName === null){
              orderDetail.clothes.pictures[i].fileName = "default.png";
            }
          }
        });
      });
        //this.originalOrder = this.savedOrder;
        ///localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
        ///this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
        ///this.orderService.changeTime(this.savedOrder.confirmDate.toString());
        ///this.orderService.changeStatus(this.savedOrder.status);
        // this.orderService.currentArticles = new BehaviorSubject(this.savedOrder.orderDetails.length.toString()).asObservable();
        this.spinner.hide();
      } else
        this.spinner.hide();
    } else {
      this.spinner.hide();
      this.logOut();
    }
  }

  saveOrUpdateOrder(noc: any){
    this.spinner.show();
    //let noc: string = (<HTMLInputElement>document.getElementById("noc")).value;
    if (noc !== undefined && noc !== null){
      if (this.savedOrder === undefined || this.savedOrder === null){
        this.savedOrder = new Order;
        this.savedOrder.confirmDate = new Date;
        this.savedOrder.creationDate = new Date;
        this.savedOrder.orderDetails = [];
        this.savedOrder.price = 0;
        this.savedOrder.sigle = false;
        this.savedOrder.status = "CONFIRMED";
        this.savedOrder.orderType = "TIENDA_FISICA";
        this.savedOrder.preparation = false;
        this.savedOrder.shipment = false;
      }

      let dataOrder = new DataOrder;
      dataOrder.nid = this.nid;
      dataOrder.orders = [this.savedOrder];
      dataOrder.noc = noc;

      this.orderService.saveStoreOrder(dataOrder).subscribe(
        data => {
          if (getToken(data)) {
            (<HTMLInputElement>document.getElementById("noc")).value = null;
            //this.getOrder();
            this.savedOrder = data.orders[0]
            this.savedOrder.orderDetails.forEach(orderDetail => {
              // Ordenamos los precios por fecha
              let prices = orderDetail.clothes.prices.filter(p => new Date(p.priceDate) < new Date(this.savedOrder.creationDate));
              orderDetail['price'] = prices.sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
          });
          } else {
            this.toastr.warning(data.errorCode.message, "ERROR");
          }
        }, error => {
          this.toastr.error("SE HA PRODUCIDO UN ERROR AL MODIFICAR EL PEDIDO", "ERROR");
        }
      );
    }
    if(this.intervalId == null || this.intervalId == undefined)
      this.startCountdown(this.savedOrder.creationDate)
    this.showClock = true
    this.clothSelected = ''
    this.sizeSelected = undefined
    this.spinner.hide();
  }

  // Función para eliminar el total de un artículo del pedido
  eliminarItem(storeTicketNumber: string, orderDetail: any){
    this.spinner.show();
    // Recorremos los pedidos para localizar el artículo a eliminar

    if(storeTicketNumber === this.savedOrder.storeTicketNumber){
      for (let i = 0; i < this.savedOrder.orderDetails.length; i++){
        if (this.savedOrder.orderDetails[i].clothes.code === orderDetail.clothes.code && this.savedOrder.orderDetails[i].size === orderDetail.size &&
          (this.savedOrder.orderDetails[i].ribbon && orderDetail.ribbon ? this.savedOrder.orderDetails[i].ribbon.id === orderDetail.ribbon.id : this.savedOrder.orderDetails[i].ribbon === orderDetail.ribbon) &&
          (this.savedOrder.orderDetails[i].job && orderDetail.job ? this.savedOrder.orderDetails[i].job.id === orderDetail.job.id : this.savedOrder.orderDetails[i].job === orderDetail.job) &&
          (this.savedOrder.orderDetails[i].weapon && orderDetail.weapon ? this.savedOrder.orderDetails[i].weapon.id === orderDetail.weapon.id : this.savedOrder.orderDetails[i].weapon === orderDetail.weapon) &&
          (this.savedOrder.orderDetails[i].generalStaff && orderDetail.generalStaff ? this.savedOrder.orderDetails[i].generalStaff.id === orderDetail.generalStaff.id : this.savedOrder.orderDetails[i].generalStaff === orderDetail.generalStaff)
        ){
          // Restamos el precio del total del artículo al pedido
          this.savedOrder.price -= this.savedOrder.orderDetails[i]['price'] * this.savedOrder.orderDetails[i].amount;
          // Eliminamos el artículo del pedido
          this.savedOrder.orderDetails.splice(i, 1);
        }
      }
    }
    // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null,
      storeTicketNumber: null
    };
    dataOrder.orders.push(this.savedOrder);
    if (this.savedOrder.orderDetails.length > 0){
      this.modifyOrder(dataOrder);
    } else {
      this.cancelarPedido(dataOrder);
    }
  }

  // Aumenta 1 la cantidad de un artículo
  aumentarCant(storeTicketNumber: string, orderDetail: any){
    //Guardo el detalle modificado para en caso de error volver al valor inicial
    this.modifiedDetail = JSON.parse(JSON.stringify(orderDetail));

    // Buscamos el pedido al que hay que sumarle un artículo
    if (this.savedOrder.storeTicketNumber === storeTicketNumber){
      // Buscamos el detalle del pedido correspondiente con el artículo
      this.savedOrder.orderDetails.forEach(detail => {
        if (detail.clothes.code === orderDetail.clothes.code && detail.size === orderDetail.size &&
            (detail.ribbon && orderDetail.ribbon ? detail.ribbon.id === orderDetail.ribbon.id : detail.ribbon === orderDetail.ribbon) &&
            (detail.job && orderDetail.job ? detail.job.id === orderDetail.job.id : detail.job === orderDetail.job) &&
            (detail.weapon && orderDetail.weapon ? detail.weapon.id === orderDetail.weapon.id : detail.weapon === orderDetail.weapon) &&
            (detail.generalStaff && orderDetail.generalStaff ? detail.generalStaff.id === orderDetail.generalStaff.id : detail.generalStaff === orderDetail.generalStaff)
        ){
          let clothPrice = detail['price'];
          return detail.clothes.nocSizes.forEach(nocSize => {
            // Comprobamos que haya stock
            if (nocSize.size === detail.size && 
                (nocSize.ribbon && detail.ribbon ? nocSize.ribbon.id === detail.ribbon.id : nocSize.ribbon === detail.ribbon) &&
                (nocSize.job && detail.job ? nocSize.job.id === detail.job.id : nocSize.job === detail.job) &&
                (nocSize.weapon && detail.weapon ? nocSize.weapon.id === detail.weapon.id : nocSize.weapon === detail.weapon) &&
                (nocSize.generalStaff && detail.generalStaff ? nocSize.generalStaff.id === detail.generalStaff.id : nocSize.generalStaff === detail.generalStaff)
            ){
              detail.amount += 1;
              return this.savedOrder.price += clothPrice;
            }
          });
        }
      });
    }

    // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    dataOrder.orders.push(this.savedOrder);
    this.modifyOrder(dataOrder);
  }

  // Disminuye 1 la cantidad de un artículo
  disminuirCant(storeTicketNumber: string, orderDetail: any){
    // Buscamos el pedido al que hay que sumarle un artículo

    if (this.savedOrder.storeTicketNumber === storeTicketNumber){
      // Buscamos el detalle del pedido correspondiente con el artículo
      for (let i = 0; i < this.savedOrder.orderDetails.length; i++){
        if (this.savedOrder.orderDetails[i].clothes.code === orderDetail.clothes.code && this.savedOrder.orderDetails[i].size === orderDetail.size &&
              (this.savedOrder.orderDetails[i].ribbon && orderDetail.ribbon
                ? this.savedOrder.orderDetails[i].ribbon.id === orderDetail.ribbon.id
                : this.savedOrder.orderDetails[i].ribbon === orderDetail.ribbon) &&
              (this.savedOrder.orderDetails[i].job && orderDetail.job
                ? this.savedOrder.orderDetails[i].job.id === orderDetail.job.id
                : this.savedOrder.orderDetails[i].job === orderDetail.job) &&
              (this.savedOrder.orderDetails[i].weapon && orderDetail.weapon
                ? this.savedOrder.orderDetails[i].weapon.id === orderDetail.weapon.id
                : this.savedOrder.orderDetails[i].weapon === orderDetail.weapon) &&
              (this.savedOrder.orderDetails[i].generalStaff && orderDetail.generalStaff
                ? this.savedOrder.orderDetails[i].generalStaff.id === orderDetail.generalStaff.id
                : this.savedOrder.orderDetails[i].generalStaff === orderDetail.generalStaff)
        ){
          let clothPrice = this.savedOrder.orderDetails[i]['price'];
          if (this.savedOrder.orderDetails[i].amount > 1){
            this.savedOrder.orderDetails[i].amount -= 1;
          } else {
            this.savedOrder.orderDetails.splice(i, 1);
          }
          this.savedOrder.price -= clothPrice;
        }
      }
    }

    // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null,
      storeTicketNumber: null
    };
    dataOrder.orders.push(this.savedOrder);
    if (this.savedOrder.orderDetails.length > 0){
      this.modifyOrder(dataOrder);
    } else {
      this.cancelarPedido(dataOrder);
    }
    //this.getOrder();
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      () => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  // Función para modificar pedidos
  modifyOrder(dataOrder: DataOrder){
    this.spinner.show();

    // Se pone el estado CONFIRMED por defecto
    this.savedOrder.status = "CONFIRMED";

    // Añadimos la fecha de confirmación
    this.savedOrder.confirmDate = new Date();

    if (dataOrder === undefined || dataOrder === null){
      dataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        user: null,
        nid: this.nid,
        orders: [this.savedOrder],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        pdfName: null,
        role: null,
        noc: null,
        storeTicketNumber: null
      };
    }

    this.orderService.modifyOrder(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("SU PEDIDO HA SIDO MODIFICADO CORRECTAMENTE", "PEDIDO MODIFICADO");
          //this.getOrder();
          this.savedOrder = data.orders[0]
          this.savedOrder.orderDetails.forEach(orderDetail => {
              // Ordenamos los precios por fecha
              let prices = orderDetail.clothes.prices.filter(p => new Date(p.priceDate) < new Date(this.savedOrder.creationDate));
              orderDetail['price'] = prices.sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
          });
          let total = this.savedOrder.orderDetails.reduce((total, d) => total + (d.amount * d.price), 0);
          this.savedOrder.price = total
        } else {
        
          if(data.errorCode.message === 'NO HAY STOCK'){
            this.savedOrder = data.orders[0]
            this.savedOrder.orderDetails.find(d=>d.clothes.name === this.modifiedDetail["clothes"]["name"] 
              && d.size === this.modifiedDetail["size"]).amount = this.modifiedDetail["amount"]
            this.savedOrder.orderDetails.forEach(orderDetail => { 
              // Ordenamos los precios por fecha
              let prices = orderDetail.clothes.prices.filter(p => new Date(p.priceDate) < new Date(this.savedOrder.creationDate));
              orderDetail['price'] = prices.sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
            });
            let total = this.savedOrder.orderDetails.reduce((total, d) => total + (d.amount * d.price), 0);
            this.savedOrder.price = total
            console.log("savedOrder", this.savedOrder);
          }
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.spinner.hide();
      }, () => {
        this.toastr.warning("SU PEDIDO NO HA SIDO MODIFICADO", "ERROR MODIFICAR PEDIDO");
        this.spinner.hide();
      }
    );
  }

  // Función para cancelar pedidos
  cancelarPedido(dataOrder: DataOrder){
    this.spinner.show();
    if (dataOrder === undefined || dataOrder === null){
      dataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        user: null,
        nid: this.nid,
        orders: [this.savedOrder],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        pdfName: null,
        role: null,
        noc: null,
        storeTicketNumber: null
      };
    }
    this.orderService.cancelOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          ///localStorage.setItem("articulos", null);
          ///this.orderService.sendUpdate("0");  
          ///this.orderService.changeTime(null);
          ///this.orderService.changeStatus(null);
          //this.orderService.currentArticles = new BehaviorSubject(null).asObservable();
          this.router.navigate(['/home']);
          this.toastr.success("PEDIDO CANCELADO CORRECTAMENTE", "PEDIDO CANCELADO");
          this.spinner.hide();

        } else {
          this.toastr.warning(data.errorCode.message, "PEDIDO NO CANCELADO");
          this.spinner.hide();
        }
      }, () => {
        this.toastr.warning("EL PEDIDO NO SE HA CANCELADO", "PEDIDO NO CANCELADO");
        this.spinner.hide();
      }
    );
  }

  showConfirmModal(){
    this.spinner.show();
    this.confirmModal.show();
  }

  hideConfirmModal(){
    this.confirmModal.hide();
  }

  // Función que comprueba si el usuario ha introducido todos los datos pesonales
  confirmarPedido(){
    let zeroAmount = this.savedOrder.orderDetails.some(d=> d.amount === 0)
    if(!zeroAmount){
      this.savedOrder.status = "FINISHED";
      // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
      let dataOrder: DataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        nid: localStorage.getItem("nid"),
        orders: [],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        user: null,
        pdfName: null,
        role: null,
        noc: null,
        storeTicketNumber: null
      };
      dataOrder.orders.push(this.savedOrder);

      this.orderService.modifyOrder(dataOrder).subscribe(
        data => {
          if (getToken(data)){
            data.errorCode = null;
            data.token = null;
            this.orderService.separateOrders(data).subscribe(
              data => {
                if (getToken(data)){
                  this.separatedOrders = data.orders;
                  this.storeTicketNumber = this.separatedOrders[0].storeTicketNumber;
                  this.checkPayment();
                } else {
                  this.toastr.warning(data.errorCode.message, "ERROR");
                }
              }, () => {
                this.toastr.error("SE HA PRODUCIDO UN ERROR AL CONFIRMAR EL PEDIDO", "ERROR");
              }
            );
          } else {
            this.toastr.warning(data.errorCode.message, "ERROR");
            this.spinner.hide()
          }
        }, () => {
          this.toastr.error("SE HA PRODUCIDO UN ERROR AL CONFIRMAR EL PEDIDO", "ERROR");
          this.spinner.hide()
        }
      );
    } else {
        this.confirmModal.hide();
        this.toastr.error("ERROR: ALGUNO DE LOS DETALLES DEL PEDIDO CONTIENE CANTIDAD 0, REVISELO Y VUELVA A CONFIRMAR ")
    }
      
  }

  // Comprobamos si se ha finalizado el pago cada 60s
  checkPayment(){
    let orderService = this.orderService;
    let savedOrder = this.savedOrder;
    let printModal = this.printModal;
    let spinner = this.spinner;
    let confirmModal = this.confirmModal;
    let timerId = setInterval(function checkOrders(){
      orderService.getFinishedOrdersPhysicalStore(savedOrder.storeTicketNumber).subscribe(
        data => {
          if (getToken(data)){
            if (data.orders !== undefined && data.orders !== null && data.orders.length > 0){
              confirmModal.hide();
              printModal.show();
              spinner.hide();
              clearInterval(timerId);
            }
          }
        }
      );
    }, 5000);
    this.spinner.hide()
  }

  //Genera el justificante del pedido
  print(){
    let data: DataOrder = new DataOrder();
    data.nid = localStorage.getItem("nid");
    data.orders = this.separatedOrders;
    data.role = localStorage.getItem("role");
    data.devolution = false;
    data.storeTicketNumber = this.storeTicketNumber;
    this.orderService.getReceiptOrders(data).subscribe(
      data => {
        if (getToken(data)) {
          if(data.receiptOrders!=null){
            const source = 'data:application/pdf;base64,'+data.receiptOrders;
            const link = document.createElement("a");
            link.href = source;
            link.download = 'ticket'+new Date()+'+.pdf';
            link.click();
            this.closePrintModal();
          }else{
            this.toastr.info("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "INFO");
            this.spinner.hide();
            this.router.navigate(['home']);
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      () => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");
      }
    )
  }

  closePrintModal(){
    this.printModal.hide();
    this.router.navigate(['home']);
  }

  getSizes(){
    this.spinner.show();
    this.sizeSelected = undefined
    this.sizes = undefined
    this.jobSelected = undefined;
    this.ribbonSelected = undefined;
    this.weaponSelected = undefined;
    this.generalStaffSelected = undefined;
    this.sizeSelectedCinta = undefined;
    if(this.clothSelected != '' && this.clothSelected != 'CINTA'){
      this.sizes = this.clothesList.filter(c=> c.name == this.clothSelected).map(s=> s.nocSizes)[0]
    }else if(this.clothSelected == 'CINTA'){
      this.sizes = this.clothesList.filter(c=> c.name == this.clothSelected).map(s=> s.nocSizes)[0]
      this.jobs = this.getUniqueByKey(this.sizes, 'job');
      this.ribbons = this.getUniqueByKey(this.sizes, 'ribbon');
      this.weapons = this.getUniqueByKey(this.sizes, 'weapon');
      this.generalStaffs = this.getUniqueByKey(this.sizes, 'generalStaff');
    }
    this.spinner.hide();
  }

  getUniqueByKey(array, key) {
    const map = new Map();
    array.forEach(item => {
      const uniqueKey = JSON.stringify(item[key]);
      if (!map.has(uniqueKey) && uniqueKey !=="null" && item[key] !== null) {
        map.set(uniqueKey, item[key]);
      }
    });
    return Array.from(map.values());
  }

  getClothesCinta(){
    this.spinner.show();
    let nocs = this.sizes.filter(c=> c.job.id == this.jobSelected.id 
                                      && c.ribbon.id == this.ribbonSelected.id 
                                      && c.weapon.id == this.weaponSelected.id 
                                      && c.generalStaff.id == this.generalStaffSelected.id);
    if(nocs.length > 0){
      this.saveOrUpdateOrder(nocs[0].noc);
    }else{
      this.jobSelected = undefined;
      this.ribbonSelected = undefined;
      this.weaponSelected = undefined;
      this.generalStaffSelected = undefined;
      this.sizeSelectedCinta = undefined;
      this.toastr.warning("CINTA NO ENCONTRADA");
      this.spinner.hide();
    }
  }

  /**
   * Paraliza un pedido para recuperarlo posteriormente
   */
  paralyze(){
    clearInterval(this.intervalId);
    this.intervalId = undefined
    this.getOrder();
  }

  /**
   * Cuenta atras de pedido recuperado
   */
  startCountdown(startTime: Date) {
    this.spinner.show()
    this.showClock = false;
    this.timeLeft = undefined
    clearInterval(this.intervalId);
    const start = new Date(startTime).getTime();
    const end = start + 2 * 60 * 60 * 1000; // suma 2 horas

    this.intervalId = setInterval(() => {
      const now = Date.now();
      const diff = end - now;

      if (diff <= 0) {
        this.timeLeft = '00:00:00';
        clearInterval(this.intervalId);
        //this.getOrder();
      } else {
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.timeLeft = this.formatTime(hours, minutes, seconds);
        this.showClock = true; 
      }
      this.spinner.hide()
    }, 1000);
    this.spinner.hide()
  }

  private formatTime(h: number, m: number, s: number): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }

  applyDetailChanges(event: any, detail: any){
    this.modifiedDetail = JSON.parse(JSON.stringify(detail))
    const value = (event.target as HTMLInputElement).value;
    if(value !== null && value !== "" && value !== "0"){
      try{
        let newAmount = Number(value)
        if(detail.amount !== newAmount){
          detail.amount = newAmount;
          let total = this.savedOrder.orderDetails.reduce((total, d) => total + (d.amount * d.price), 0);
          this.savedOrder.price = total
        }
      } catch(error){
        this.toastr.error("EL VALOR INTRODUCIDO ES INCORRECTO")
      }
    } else {
      this.toastr.error("EL VALOR INTRODUCIDO ES INCORRECTO")
      //input.value = detail.amount.toString();
    }

    // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    dataOrder.orders.push(this.savedOrder);
    this.modifyOrder(dataOrder);
    
  }

}
